import React, {useState} from "react";
import {TouchableOpacity, View} from "react-native";
import PtOrderHistorySearch from "./../pt-order-history-search/pt-order-history-search";
import PtText from "../../core/pt-text/pt-text";
import PtOrderHistoryFilter from "./../pt-order-history-filter/pt-order-history-filter";
import PtIcon from "../../core/pt-icon/pt-icon";
import {getTranslation} from "../../../helpers/getTranslation";
import {PtOrderHistorySearchFilterWrapperProps} from './pt-order-history-search-filter-wrapper-props';
import {styles} from './pt-order-history-search-filter-wrapper-styles';

const renderFiltersTrigger = (showFilters: boolean, toggleFilters: any) => {
  return (
      <View style={[styles.triggerContainer]}>
        <TouchableOpacity onPress={() => toggleFilters()}>
          <PtText style={styles.trigger}>
            {showFilters ?
              <PtIcon iconName={'up'} iconSize={16} style={styles.triggerIcon}/>
              :
              <PtIcon iconName={'down'} iconSize={16} style={styles.triggerIcon}/>
            }
            {getTranslation('order.history.show.filters.label')}
          </PtText>
        </TouchableOpacity>
      </View>
  )
}

const renderSearchTrigger = (showSearch: boolean, toggleSearch: any) => {
  return (
      <View style={[styles.triggerContainer]}>
        <TouchableOpacity onPress={() => toggleSearch()}>
          <PtText style={styles.trigger}>
            {showSearch ?
              <PtIcon iconName={'up'} iconSize={16} style={styles.triggerIcon}/>
              :
              <PtIcon iconName={'down'} iconSize={16} style={styles.triggerIcon}/>
            }
            {getTranslation('order.history.show.search.label')}
          </PtText>
        </TouchableOpacity>
      </View>
  )
}

const renderResetTrigger = (resetSearchAndFilters:any) => {
  return (
    <View style={[styles.triggerContainer]}>
      <TouchableOpacity onPress={() => resetSearchAndFilters()}>
        <PtText style={styles.trigger}>
          <PtIcon iconName={'reset'} iconSize={16} style={styles.triggerIcon}/>
          {getTranslation('order.history.reset.label')}
        </PtText>
      </TouchableOpacity>
    </View>
  )
}

export default function PtOrderHistorySearchFilterWrapper(props: PtOrderHistorySearchFilterWrapperProps) {

  /** data */
  const searchOptions = props.searchOptions ? props.searchOptions : [];
  const filtersOptions = props.filtersOptions ? props.filtersOptions : {};

  /** settings */
  const containerHidden = props.hide ? styles.containerHidden : null;
  const [showSearch, setShowSearch] = useState(props.showSearch || false);
  const [showFilters, setShowFilters] = useState(props.showFilters || false);

  /** pass through handlers */
  const orderStatusFilterChangedHandler = props.orderStatusFilterChangedHandler;
  const startDateChangedHandler = props.startDateChangedHandler;
  const endDateChangedHandler = props.endDateChangedHandler;
  const applyFiltersHandler = props.applyFiltersHandler;
  const searchTermChangedHandler = props.searchTermChangedHandler;
  const searchTypeChangedHandler = props.searchTypeChangedHandler;
  const searchHandler = props.searchHandler;

  const toggleSearch = () => {
    setShowSearch(!showSearch);
  }

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  }

  const resetSearchAndFilters = () => {
    props.resetHandler();
  }

  /** renders */
  const getFiltersTrigger = renderFiltersTrigger(showFilters, toggleFilters);
  const getSearchTrigger = renderSearchTrigger(showSearch, toggleSearch);
  const getResetTrigger = renderResetTrigger(resetSearchAndFilters);

  return (
    <View style={[styles.wrapperContainer, containerHidden]}>
      <View style={[styles.actionsStrip]}>
        {getFiltersTrigger}
        {getResetTrigger}
        {getSearchTrigger}
      </View>
      <PtOrderHistorySearch
        show={showSearch}
        searchOptions={searchOptions}
        requestParams={props.requestParams}
        searchTermChangedHandler = {searchTermChangedHandler}
        searchTypeChangedHandler = {searchTypeChangedHandler}
        searchHandler = {searchHandler}
      />
      <PtOrderHistoryFilter
        show={showFilters}
        filtersOptions={filtersOptions}
        requestParams={props.requestParams}
        orderStatusFilterChangedHandler = {orderStatusFilterChangedHandler}
        startDateChangedHandler = {startDateChangedHandler}
        endDateChangedHandler = {endDateChangedHandler}
        applyFiltersHandler = {applyFiltersHandler}
      />
      {showSearch || showFilters ?
        <View style={[styles.actionsStrip]}>
          {showFilters ? getFiltersTrigger : <View style={[styles.triggerContainer]}/>}
          {getResetTrigger}
          {showSearch ? getSearchTrigger : <View style={[styles.triggerContainer]}/>}
        </View>
        : null
      }
    </View>
  )

}